import jwtAxios from '@crema/services/auth/jwt-auth/jwt-api';

export const sendEmail = (message: string) => {
  const response = jwtAxios.post('/sendInfoToAdmin', {
    email: message,
  });
  return response;
};
